import { render, staticRenderFns } from "./CatsList.vue?vue&type=template&id=12dbbb22&scoped=true"
import script from "./CatsList.vue?vue&type=script&lang=js"
export * from "./CatsList.vue?vue&type=script&lang=js"
import style0 from "./CatsList.vue?vue&type=style&index=0&id=12dbbb22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dbbb22",
  null
  
)

export default component.exports